export enum ParamField {
    Global = 'q',
    Semantic = 'sq',
    FullText = 'ftq',
    Facets = 'f',
    AdvancedSearch = 'advQ',
    Fields = 'fields',
    ColumnFilter = 'cf',
    Page = 'page',
    PageSize = 'pageSize',
    Sort = 'sort',
    View = 'view',
    SavedQuery = 'sqId'
}

export type UrlQueryParams = Partial<{
    [key in ParamField]: string | undefined;
}>;
